module.exports = __webpack_public_path__ + "img/triple.e1b5a127.jpg";